import Marquee from 'react-fast-marquee';
import { Box, Container, styled } from '@mui/material';

// Styled components using MUI's styled API
const MarqueeWrapper = styled(Box)(({ theme }) => ({
  // marginTop: theme.spacing(8),
  padding: theme.spacing(4.5, 0),
  width: '100%',
  borderRadius: theme.spacing(2),
  border: `1px solid ${theme.palette.primary.primary_100}`,
}));

const SliderContainer = styled(Box)({
  overflow: 'hidden',
});

const FlexContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
});

// Fixed width with exactly 30px margin on each side (60px total between logos)
const LogoContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  margin: '0 30px', // Exactly 30px on each side (60px between logos)
  transition: 'transform 0.3s ease', // Smooth transition for hover effect
});

const LogoImage = styled('img')({
  maxWidth: '100px',
  maxHeight: '21px',
  objectFit: 'contain',
});

const CustomersMarquee = () => {
  const data = [
    {
      img: '/static/img/customers-logos/esprofiler.webp',
    },
    {
      img: '/static/img/customers-logos/singular-ai.webp',
    },
    {
      img: '/static/img/customers-logos/resound.webp',
    },
    {
      img: '/static/img/customers-logos/makemycv.webp',
    },
    {
      img: '/static/img/customers-logos/capua.webp',
    },
    {
      img: '/static/img/customers-logos/recruiterbolt.webp',
    },
    {
      img: '/static/img/customers-logos/consult-agora.webp',
    },
    {
      img: '/static/img/customers-logos/quilty-space.webp',
    },
  ];

  return (
    <MarqueeWrapper>
      <Container sx={{ padding: '0 !important' }}>
        <SliderContainer>
          <Marquee gradient={false} speed={50} pauseOnHover gap={0}>
            <FlexContainer>
              {data.map((item, idx) => (
                <LogoContainer key={idx}>
                  <LogoImage src={item.img} alt="customer logo" />
                </LogoContainer>
              ))}
            </FlexContainer>
          </Marquee>
        </SliderContainer>
      </Container>
    </MarqueeWrapper>
  );
};

export default CustomersMarquee;
